import { PropsWithChildren } from "react";
import { ComplaintsArea } from "./area";
import { ComplaintsPoint } from "@shared/types";

export type Perspective = {
  SvgComponent: React.FunctionComponent<
    React.ComponentProps<"svg"> & {
      title?: string;
      titleId?: string;
      desc?: string;
      descId?: string;
    }
  >;
  height: number;
  width: number;
};

export type DetailedMapProps = {
  perspective: Perspective;
  complaintsPoints: ComplaintsPoint[];
  handleAddComplaintsPoint: (cx: number, cy: number) => void;
  handleRemoveComplaintsPoint: (id: string) => void;
};

export const DetailedMap: React.FC<PropsWithChildren<DetailedMapProps>> = ({
  children,
  perspective,
  complaintsPoints,
  handleAddComplaintsPoint,
  handleRemoveComplaintsPoint,
}) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <svg
        width={perspective.width}
        height={perspective.height}
        className="h-full w-full text-gray-600 overflow-visible"
        viewBox={`0 0 ${perspective.width} ${perspective.height}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow
              dx="0"
              dy="0"
              stdDeviation="4"
              floodColor="#000000"
              floodOpacity="0.4"
            />
          </filter>
          <radialGradient id="grad" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
            <stop
              offset="40%"
              style={{ stopColor: "#FF0000", stopOpacity: 0.8 }}
            />
            <stop
              offset="100%"
              style={{ stopColor: "#FF0000", stopOpacity: 0 }}
            />
          </radialGradient>
          <radialGradient
            id="grad-hover"
            cx="50%"
            cy="50%"
            r="50%"
            fx="50%"
            fy="50%"
          >
            <stop
              offset="40%"
              style={{ stopColor: "#CC0000", stopOpacity: 0.8 }}
            />
            <stop
              offset="100%"
              style={{ stopColor: "#CC0000", stopOpacity: 0 }}
            />
          </radialGradient>
        </defs>
        <perspective.SvgComponent
          className="cursor-pointer"
          onClick={(event) => {
            const rect = event.currentTarget.getBoundingClientRect();

            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            const relation = perspective.width / rect.width;

            handleAddComplaintsPoint(x * relation, y * relation);
          }}
        />
        {complaintsPoints.map((complaintsPoint) => (
          <ComplaintsArea
            key={complaintsPoint.id}
            cx={complaintsPoint.cx}
            cy={complaintsPoint.cy}
            onClick={() => {
              handleRemoveComplaintsPoint(complaintsPoint.id);
            }}
          />
        ))}
      </svg>

      {children}
    </div>
  );
};
